import FormItem from '../form/form-item.vue'

/* istanbul ignore next */
FormItem.install = function (Vue) {
  Vue.component(FormItem.name, FormItem)
}

export default FormItem
